import { IUser } from './user';

export interface IOrder {
  _id?: string;
  userId: string;
  phoneNumber: string;
  name: string;
  status: EOrderStatus;
  user?: IUser;
  total: number;
  shippingAddress: IOrderShippingAddress;
  items: IOrderItem[];
  note?: string;
  paymentMethod?: EPaymentMethod;
  unPaidAmount?: number;
  vat: number;
  isTax: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IFormOrder {
  userId: string;
  phoneNumber: string;
  name: string;
  total: number;
  shippingAddress: IOrderShippingAddress;
  items: IOrderItem[];
  note?: string;
  paymentMethod?: EPaymentMethod;
  isTax: boolean;
}

export enum EPaymentMethod {
  COD = 'COD',
  BANK_TRANSFER = 'BANK_TRANSFER',
}

export interface IOrderItem {
  productId: string;
  quantity: number;
  unitName: string;
  price: number;
  damagedQuantity?: number;
  refundAmount?: number;
  images?: string[];
  name?: string;
  code?: string;
  tax?: number;
}

export interface IOrderShippingAddress {
  address: string;
  city: string;
  ward: string;
}

export enum EOrderStatus {
  PENDING = 'PENDING',
  SHIPPING = 'SHIPPING',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  CONFIRM = 'CONFIRM',
  PAID = 'PAID',
  DEBT = 'DEBT',
}
